import {
  AuthenticationResult,
  PublicClientApplication,
} from "@azure/msal-browser";
import warn from "../../constants/toast";
import store from "../../store";
import { signInRequest } from "../../store/ducks/auth/actions";
import { config, msalInstance } from "../../utils/auth_azure";
import { obterTokenConexaoNoLogin } from "../conexaoAuth";

export default async function Auth(instance?: PublicClientApplication) {
  try {
    store.dispatch({ type: "SET_LOADING_LOGIN", payload: true });

    // Se não foi passado 'instance', use o msalInstance padrão
    const pca = instance || msalInstance;

    // login via popup
    const response: AuthenticationResult | undefined = await pca.loginPopup({
      scopes: config.scopes,
      prompt: "select_account",
    });

    if (response) {
      if (response.account) {
        // `setActiveAccount` antes de qualquer `acquireTokenSilent`: sem conta ativa, as aquisições
        // posteriores dependem de `getAllAccounts()[0]`, que devolve a conta errada quando há mais
        // de uma no cache — e nenhuma quando o cache foi limpo.
        pca.setActiveAccount(response.account);

        // O ID token que o login acabou de devolver é a credencial que o Conexão aceita — ver o
        // cabeçalho de `conexaoAuth.ts`. Passá-lo daqui dispensa uma renovação silenciosa logo após
        // o login, e a troca acontece cedo o bastante para as telas encontrarem o token pronto.
        await obterTokenConexaoNoLogin(pca, response.account, response.idToken);
      }

      store.dispatch(
        signInRequest(response.accessToken, response.account?.username)
      );
    }
  } catch (error) {
    store.dispatch({ type: "SET_LOADING_LOGIN", payload: false });
    warn.wargingAlert("Não foi possível realizar sua autenticação!");
  }
}
